const DICELACANCION_HOSTS = new Set(['dicelacancion.com', 'www.dicelacancion.com']);

export type BrandId = 'dicelacancion' | 'mixgenie';

export function detectBrand(): BrandId {
  if (typeof window === 'undefined') return 'mixgenie';
  return DICELACANCION_HOSTS.has(window.location.hostname) ? 'dicelacancion' : 'mixgenie';
}

/**
 * Brand display names are intentionally NOT localized. The brand is a
 * proper noun — "Dice la canción by MixGenie" stays the same in English,
 * Spanish, and Portuguese, the same way "Coca-Cola" or "BMW" doesn't get
 * translated when you switch language. This avoids the i18n-bundle drift
 * that previously had `en.brand.dicelacancion = "DiceLaCancion by MixGenie"`
 * (no spaces) but `es.brand.dicelacancion = "Dice la canción"` (different
 * form) — same brand, two different visual strings.
 */
const BRAND_NAMES: Record<BrandId, string> = {
  dicelacancion: 'Dice la canción by MixGenie',
  mixgenie: 'MixGenie',
};

export function useBrand() {
  const id = detectBrand();
  return {
    id,
    name: BRAND_NAMES[id],
    isDiceLaCancion: id === 'dicelacancion',
    // Logo asset — `/logo/logo_single.png` ships in public/ today.
    logoSrc: '/logo/logo_single.png',
  };
}
